const html = document.getElementsByTagName('html');
const menuBtn = document.getElementById('js-toggle-menu');
const navigation = document.getElementById('js-navigation');
const body = document.getElementById('body');

if (menuBtn) {
	menuBtn.addEventListener('click', (e) => {
		e.preventDefault();
		html[0].classList.toggle('-menu-open');
	});
}

// Close menu
const closeBtns = navigation.querySelectorAll('.js-close-menu');

for (const closeBtn of closeBtns) {
	closeBtn.addEventListener('click', (e) => {
		html[0].classList.remove('-menu-open');
		html[0].classList.add('-menu-close');
	});
}

// Close menu when click menu item
const menuItem = navigation.querySelectorAll('.js-menu-item');

for (const item of menuItem) {
	item.addEventListener('click', () => {
		html[0].classList.remove('-menu-open');
		html[0].classList.add('-menu-close');
	});
}
